<template>
    <div class="animated fadeIn">
        <component-header
            title="Access Rule"
            :isLoading="loading"
            :hasSearch="false"
            :hasReload="true"
            @reload-data="accessRule"
            :hasRadio="false"
            :hasCreate="true"
            :hasback="false"
            @create-press="$router.push({ path: '/setup/accessrule/create' })"
        />
        <b-row>
            <b-col>
                <b-card>
                    <b-table
                        style="border-radius: 12px"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :current-page="currentPage"
                        :per-page="10"
                        :items="accessrulesList"
                        thead-class="header"
                        class="mt-3"
                        :fields="Columns"
                        show-empty
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <b-button
                                    size="sm"
                                    class="button-circle mr-2 btn-primary"
                                    v-b-modal="`modal-${data.index}`"
                                >
                                    <i class="fa fa-eye"></i>
                                </b-button>
                                <b-modal
                                    :id="`modal-${data.index}`"
                                    size="md"
                                    centered
                                    hide-footer
                                    :ref="`modal-${data.index}`"
                                    title="View Access Rules"
                                >
                                    <b-row class="mx-1 my-2">
                                        <label for="planName">Name</label>
                                        <b-form-input
                                            class=""
                                            style="width: 100%"
                                            id="planName"
                                            disabled
                                            inputType="text"
                                            v-model="data.item.Name"
                                        />
                                    </b-row>
                                    <b-row class="mx-1 my-2">
                                        <label for="keys">keys</label>
                                        <b-form-input
                                            id="keys"
                                            disabled
                                            class=""
                                            style="width: 100%"
                                            inputType="text"
                                            v-model="data.item.Keys"
                                        />
                                    </b-row>
                                     <div class="text-center mt-3">
                                        <b-button
                                          variant="secondary"
                                          size="sm"
                                          @click="$refs[`modal-${data.index}`].hide()"
                                        >
                                          Cancel
                                        </b-button>
                                    </div>
                                </b-modal>
                                <router-link
                                    :to="{
                                        name: 'access rule edit',
                                        params: {
                                            id: data.item.itemId,
                                            data: data.item,
                                        },
                                    }"
                                >
                                    <b-button
                                        size="sm"
                                        class="button-circle mr-2 btn-primary"
                                        style="
                                            background: #fe7b08;
                                            border: #fe7b08;
                                        "
                                    >
                                        <i class="fas fa-pencil-alt edit"></i>
                                    </b-button>
                                </router-link>
                            </div>
                        </template>
                        <template v-slot:empty="scope">
                            <h4>{{ scope.emptyText }}</h4>
                        </template>
                    </b-table>
                    <div style="float: right" v-if="accessrulesList.length > 0">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="10"
                            :total-rows="accessrulesList.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import componentHeader from "@/components/componentNewHeader";

export default {
    name: "access-rule",
    components: {
        ebButton,
        loader,
        componentHeader,
    },
    data() {
        return {
            loading: false,
            perPage: 30,
            hover: true,
            loading: false,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            context: "Add",
            sortBy: "createdAt",
            sortDesc: true,
            faqModal: false,
            header: "Edit Faq",
            subscriptionData: {},
            Columns: [
                {
                    key: "Name",
                    sortable: true,
                },
                {
                    key: "Keys",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        accessrulesList() {
            let data = this.$store.getters["accessrule/GetAccessRuleList"];
            this.loading = false;
            if (Array.isArray(data) && data.length > 0) {
                return data.map((d) => {
                    return {
                        Name: d?.name.toUpperCase(),
                        Keys: d?.keys,
                        itemId: d?._id,
                    };
                });
            }
            return [];
        },
    },
    methods: {
        async accessRule() {
            this.loading = true;
            await this.$store
                .dispatch("accessrule/accessRuleList")
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                    }
                });
            this.loading = false;
        },
    },
    async mounted() {
        await this.accessRule();
    },
};
</script>
<style scoped>
:deep .close {
    color: black;
}
</style>
<style lang="sass" scoped>
.edit
  color: white !important
.form-div label
  margin-top: 8px
</style>
